function initContentToggler() {
  document
    .querySelectorAll('[data-default-visible="false"]')
    .forEach((element) => {
      element.closest('div').classList.add('hidden');
    });

  const currentOffer = typeof offer !== 'undefined' ? offer : null;

  if (!currentOffer) {
    // On page content
    // Hide parents of non-eligible content
    document
      .querySelectorAll(
        '[data-gwp-content="gwp-offer"], [data-gwp-content="non-gwp-offer"]',
      )
      .forEach((element) => {
        element.closest('div').classList.add('hidden');
      });
    // Display eligible content
    document
      .querySelectorAll(
        '[data-gwp-content="gwp-offer-fallback"], [data-gwp-content="non-gwp-offer-fallback"], [data-gwp-content="no-offer-fallback"]',
      )
      .forEach((element) => {
        element.classList.remove('hidden');
        element.closest('div').classList.remove('hidden');
      });

    // Megamenu content
    document
      .querySelectorAll(
        '[data-promo-gwp-state="gwp-offer"], [data-promo-gwp-state="non-gwp-offer"]',
      )
      .forEach((element) => {
        const grandparent = element.closest('.megamenu__promo');
        const parent = element.closest('[data-content="promo-image-parent"]');
        const revealParent = grandparent.querySelector(
          '[data-content="promo-image-fallback-parent"]',
        );
        parent.classList.add('hidden');
        if (revealParent) {
          revealParent.classList.remove('hidden');
        }
      });
  } else {
    const offerData = parseOfferDetails(currentOffer);
    const pairedOfferData = offerData.pairedOffer
      ? parseOfferDetails(offerData.pairedOffer)
      : null;
    if (
      (offerData.whistle_gift && offerData.whistle_gift === true) ||
      (pairedOfferData &&
        pairedOfferData.whistle_gift &&
        pairedOfferData.whistle_gift === true)
    ) {
      // WHISTLE OFFER APPLICABLE
      // On page content
      // Hide parents of non-eligible content
      document
        .querySelectorAll(
          '[data-gwp-content="non-gwp-offer"], [data-gwp-content="gwp-offer-fallback"], [data-gwp-content="no-offer-fallback"]',
        )
        .forEach((element) => {
          element.closest('div').classList.add('hidden');
        });
      // Display eligible content
      document
        .querySelectorAll('[data-gwp-content="gwp-offer"]')
        .forEach((element) => {
          element.classList.remove('hidden');
          element.closest('div').classList.remove('hidden');
        });

      // Megamenu content
      document
        .querySelectorAll('[data-promo-gwp-state="non-gwp-offer"]')
        .forEach((element) => {
          const grandparent = element.closest('.megamenu__promo');
          const parent = element.closest('[data-content="promo-image-parent"]');
          const revealParent = grandparent.querySelector(
            '[data-content="promo-image-fallback-parent"]',
          );
          parent.classList.add('hidden');
          if (revealParent) {
            revealParent.classList.remove('hidden');
          }
        });
    } else {
      // NON-WHISTLE OFFER APPLICABLE
      // On page content
      // Hide parents of non-eligible content
      document
        .querySelectorAll(
          '[data-gwp-content="gwp-offer"], [data-gwp-content="non-gwp-offer-fallback"], [data-gwp-content="no-offer-fallback"]',
        )
        .forEach((element) => {
          element.closest('div').classList.add('hidden');
        });
      // Display eligible content
      document
        .querySelectorAll('[data-gwp-content="non-gwp-offer"]')
        .forEach((element) => {
          element.classList.remove('hidden');
          element.closest('div').classList.remove('hidden');
        });

      // Megamenu content
      document
        .querySelectorAll('[data-promo-gwp-state="gwp-offer"]')
        .forEach((element) => {
          const grandparent = element.closest('.megamenu__promo');
          const parent = element.closest('[data-content="promo-image-parent"]');
          const revealParent = grandparent.querySelector(
            '[data-content="promo-image-fallback-parent"]',
          );
          parent.classList.add('hidden');
          if (revealParent) {
            revealParent.classList.remove('hidden');
          }
        });
    }
  }
}

document.addEventListener('DOMContentLoaded', initContentToggler);
